import { ISelectedBunker } from "@/configurator/ts/catalog.types";

  // выбирает пикер по id
export const getCurrentItem = (pickerData: any, id: undefined | string | number): ISelectedBunker | null => {
    const res = pickerData?.data.find(
      (item: ISelectedBunker) => item.id === Number(id)
    );
    return res;
  };